import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import AccessDeniedPage from '../pages/AccessDeniedPage';

const ProtectedRoute = ({ children, module }) => {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    // Redirect to login but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If a specific module permission is required, check it
  if (module && !hasPermission(module)) {
    return <AccessDeniedPage />;
  }

  return children;
};

export default ProtectedRoute;
